'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

var _SignalDial = require('../sprites/SignalDial');

var _SignalDial2 = _interopRequireDefault(_SignalDial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Phaser$Group) {
  _inherits(_class, _Phaser$Group);

  function _class(_ref) {
    var game = _ref.game;

    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game));

    _this.signalDial = new _SignalDial2.default({
      game: _this.game,
      x: 200,
      y: 130
    });
    _this.add(_this.signalDial);
    _this.signalDial.inputEnabled = true;
    _this.signalDial.input.useHandCursor = true;
    _this.signalDial.events.onInputDown.add(_this.onSignalDialClick, _this);

    _this.text = game.add.text(300, 100, '', {
      font: '60px Courier New',
      fill: '#00FFEA',
      smoothed: false
    }, _this);
    _this.add(_this.text);

    _this.signalSettings = ["12.3", "45.6", "78.9", "99.8"];
    _this.settingIndex = 0;

    _this.text.text = _this.signalSettings[_this.settingIndex];

    _this.onSettingChangeSignal = new _phaser2.default.Signal();
    return _this;
  }

  _createClass(_class, [{
    key: 'onSignalDialClick',
    value: function onSignalDialClick() {
      this.signalDial.rotation = (this.signalDial.rotation + 20) % 360;

      this.settingIndex = (this.settingIndex + 1) % this.signalSettings.length;
      this.text.text = this.signalSettings[this.settingIndex];

      var currentSetting = this.signalSettings[this.settingIndex];
      this.onSettingChangeSignal.dispatch(currentSetting);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.signalDial.input.useHandCursor = false;
      this.signalDial.inputEnabled = false;
    }
  }]);

  return _class;
}(_phaser2.default.Group);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/ui/SignalControl.js
// module id = 371
// module chunks = 0